import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { MotorsDraftFacade, RouterFacade } from '@classifieds-sell/state';
import { StepIds } from 'libs/motors-ui/src/lib/models/motors-step/motors-step-model';
import { MotorsVehicleDetailsDetailsSectionComponent } from 'libs/motors-ui/src/lib/sections/motors-vehicle-details-details-section/motors-vehicle-details-details-section.component';
import { MotorsPageBase } from '../../../motors-page-base';

@Component({
    templateUrl: './motors-vehicle-details-page.component.html',
    styleUrls: ['./motors-vehicle-details-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BoatsAndMarineVehicleDetailsPageComponent
    extends MotorsPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    @ViewChild(MotorsVehicleDetailsDetailsSectionComponent, {
        read: MotorsVehicleDetailsDetailsSectionComponent
    })
    motorsVehicleDetailsDetailsSectionComponent: MotorsVehicleDetailsDetailsSectionComponent;

    constructor(draftFacade: MotorsDraftFacade, routerFacade: RouterFacade) {
        super(StepIds.vehicleDetails, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewInit() {
        super.registerSection(this.motorsVehicleDetailsDetailsSectionComponent);
    }
}
